export const ENGINE_FILTER_SHORT_NAME = "engineRange"
export const engineDefault = [0, 2000]

const sN = ENGINE_FILTER_SHORT_NAME
const eD = engineDefault

export const ENGINE_FILTER_CONFIG = {
  short_name: sN,
  default_values: eD,
  is_default: value => testEngineDefault(value), //right before clean up
  format_to_api: value => formatEngineForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: value => formatEngineFromURL(value) //
}

export const formatEngineFromURL = value => {
  let cleanValue = null
  if (value) {
    if (value instanceof Array) {
      if (value.length === 2) {
        //cast them to numbers
        let minEngine = Number(value[0])
        let maxEngine = Number(value[1])
        if (!isNaN(minEngine) && !isNaN(maxEngine)) {
          if (minEngine < maxEngine) {
            //At somepoint we should round these to match the slider?
            //eh, doesn't matter. we'll do this later. only a problem if some one
            //manually messes this up.
            cleanValue = []
            cleanValue[0] = minEngine
            cleanValue[1] = maxEngine
          }
        }
      }
    }
  }

  return cleanValue
}

export const buildEngineLabel = (currentEngines) => {
  let engineLabel = ""

  if (
    currentEngines[0] === engineDefault[0] &&
    currentEngines[1] !== engineDefault[1]
  ) {
    engineLabel = engineDefault[0] + "cc - " + currentEngines[1] + "cc"
  }

  if (
    currentEngines[0] !== engineDefault[0] &&
    currentEngines[1] === engineDefault[1]
  ) {
    engineLabel = currentEngines[0] + "cc - " + engineDefault[1] + "cc"
  }

  if (
    currentEngines[0] !== engineDefault[0] &&
    currentEngines[1] !== engineDefault[1]
  ) {
    engineLabel = currentEngines[0] + "cc - " + currentEngines[1] + "cc"
  }

  if (
    currentEngines[0] === engineDefault[0] &&
    currentEngines[1] === engineDefault[1]
  ) {
    engineLabel = "All Engines"
  }

  return engineLabel
}

export const isEngineRangeDefault = value => {
  if (value[0] === engineDefault[0] && value[1] === engineDefault[1]) {
    return true
  } else {
    return false
  }
}
//////FOR API SETTING UP
export const formatEngineForAPI = value => {
  if (value) {
    return {
      min_engine: value[0],
      max_engine: value[1]
    }
  } else {
    return {}
  }
}

export const testEngineDefault = value => {
  return isEngineRangeDefault(value)
}
